export default __webpack_public_path__ + "static/media/cadeaux-4.36941854.jpeg";